import {Brick, registerBrick} from 'olympe';

/**
 * Extract company codes from catalogs payload
 */
export default class GetCompanyCodesFromCatalogsPayload extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} payload
     * @param {function(string[])} setCompanyCodes
     */
    update($, [payload], [setCompanyCodes]) {
        const parsedData = JSON.parse(payload);
        const companyCodes = parsedData.map((item) => item.company_code.trim());
        setCompanyCodes(companyCodes);
    }
}

registerBrick('019c24274a0b8667da61', GetCompanyCodesFromCatalogsPayload);
